export { TenderAwardsComponent } from './tender-awards.component';
export { TenderAwardsSearchBarComponent } from './components/tender-awards-search-bar/tender-awards-search-bar.component';
